import * as React from 'react';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
interface BazRatingProps {
  readOnly: boolean;
  defaultValue?: number;
  numReviews?: number;
}

const useStyles = makeStyles({
  totalReview: {
    marginLeft:'8px',
    marginTop: '4px'
  }
});

export default function BazzRating(props: BazRatingProps) {
    const { readOnly = false, defaultValue = 2.5, numReviews = 0 } = props;
    const classes = useStyles()
  return (
    <Box component="h6" display="inline-flex">
      <Stack spacing={1}>
        <Rating name="half-rating" defaultValue={defaultValue} precision={0.5} readOnly={readOnly} />
      </Stack>
      {numReviews > 0 && 
				<span className={classes.totalReview}>{numReviews} Reviews</span>}
    </Box>
  );
}
